export default {
  gender: [
    { id: 1, title: 'Male' },
    { id: 0, title: 'Female' }
  ],
  licenseType: [
    { id: 1, title: '1' },
    { id: 2, title: '2' }
  ]
}
